import React, { useRef, useState, useEffect } from 'react';
import css from './main.module.css';
import { useTranslation } from 'react-i18next';
import gridIcon from '../../img/grid.png';
import playButtonIcon from '../../img/play-button.png';
import AllTems from "./allTems";

const NavigationTabs = ({
  activeTab,
  setActiveTab,
  setActiveMyVideosTab,
  categories,
  selectedCategoryIds,
  onCategoryClick,
  selectedLevel,
  setSelectedLevel,
  allLevels,
  onLevelFilter,
  onClearAllFilters
}) => {
  const { t } = useTranslation();
  const anchorRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const navbarLinksRef = useRef(null);

  const handleCategoryClickWithTab = (categoryId) => {
    if (activeTab !== 'all videos') {
      setActiveTab('all videos');
      setTimeout(() => onCategoryClick(categoryId), 0);
    } else {
      onCategoryClick(categoryId);
    }
  };
  const handleLevelFilterWithTab = (levelKey) => {
    if (activeTab !== 'all videos') {
      setActiveTab('all videos');
      setTimeout(() => onLevelFilter(levelKey), 0);
    } else {
      onLevelFilter(levelKey);
    }
  };
  const handleClearAllFiltersWithTab = () => {
    if (activeTab !== 'all videos') {
      setActiveTab('all videos');
      setTimeout(() => onClearAllFilters(), 0);
    } else {
      onClearAllFilters();
    }
  };


  const [scrollTick, setScrollTick] = useState(0);

  const handleNavbarLinksScroll = () => {
    setScrollTick(prev => prev + 1);
  };

  return (
    <div className={css.tabsWithFilters}>
      <div className={css.userNavbar}>
        <div className={css.navbarLinks}
          ref={navbarLinksRef}
          onScroll={() => {
            if (typeof handleNavbarLinksScroll === 'function') {
              handleNavbarLinksScroll();
            }
          }}
        >
          {/* My Learning Tab */}
          <div
            className={`${css.navbarLink} ${activeTab !== 'all videos' ? css.activeNavLink : ''}`}
            onClick={() => {
              if (activeTab !== 'my learning') {
                setActiveTab('my learning');
                if (typeof setActiveMyVideosTab === 'function') {
                  setActiveMyVideosTab('all my videos');
                }
                // Clear all filters when switching to My Learning
                handleClearAllFiltersWithTab();
              }
            }}
          >
            <img src={playButtonIcon} alt={t('My learning')} className={css.navbarIcon} />
            <span>{t("My learning")}</span>
          </div>

          {/* All Videos Tab */}
          <div
            className={`${css.navbarLink} ${activeTab === 'all videos' ? css.activeNavLink : ''}`}
            onClick={() => {
              setActiveTab('all videos')
              if (setActiveMyVideosTab) {
                setActiveMyVideosTab(null)
                handleClearAllFiltersWithTab();
              }
            }}
          >
            <img src={gridIcon} alt={t('All Videos')} className={css.navbarIcon} />
            <span>{t("All Videos")}</span>
          </div>
          <AllTems
            categories={categories}
            onCategoryClick={handleCategoryClickWithTab}
            selectedCategory={selectedCategoryIds}
            onLevelFilter={handleLevelFilterWithTab}
            selectedLevel={selectedLevel}
            setSelectedLevel={setSelectedLevel}
            allLevels={allLevels}
            onClearAllFilters={handleClearAllFiltersWithTab}
            scrollTick={scrollTick} // <<<< pass this
          />
        </div>
      </div>
      {/* Filters below tabs */}

    </div>
  );
};

export default NavigationTabs;